import {
  Injectable,
  NgZone,
} from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { PusherService } from './pusher.service';

@Injectable()
export class NotificationsService {
  private channels = {};

  constructor(
    private ngZone: NgZone,
    private pusherService: PusherService,
  ) {}

  channel(channelName): Observable<any> {
    let channel = this.channels[channelName];
    if (!channel) {
      const subject = new Subject<any>();
      const subscription = this.pusherService.pusher.subscribe(channelName);
      subscription.bind('events', data => {
        this.ngZone.run(() => subject.next(data));
      });
      channel = this.channels[channelName] = {
        subscription: subscription,
        subject: subject,
      };
    }
    return channel['subject'];
  }
}
